export default {
	title: "Betalingsmetoder",
	tips: "Kjære bruker, vennligst fyll ut din ERC20/TRC20 adresse. Vennligst ikke oppgi dine bankkontodetaljer og passord",
	form: {
		TransactionPassword: "Transaksjonspassord",
		Address: "Lommebokadresse"
	},
	label: ["Banknavn", "Filialkode", "Filialnavn", "Innskuddstype", "Kontonummer", "Kontoeier"],
	tabs: ["Bankkort", "Nettverk"],
	delete: "Slett",
	default: "Standard",
	create: "Opprett",
	type: "Uttakstype",
	verifying: "verifiserer",
	VerifyWalletAddress: "Bekreft lommebokadresse",
	defaultAccount: "Standard Uttakskonto",
	deleteMsg: "Er du sikker på at du vil slette?"
};
